import React, { useState } from 'react';

import { Box, Typography } from '@mui/material';

import clsx from 'clsx';

import { AvatarTypes } from '../../../../components/designe/app-avatar/AppAvatar';
import AppDocsViewer from '../../../../components/designe/app-docs-viewer/AppDocsViewer';
import AppEntityAvatar, {
  AvatarSize,
} from '../../../../components/designe/app-entity-avatar/AppEntityAvatar';
import AppFile from '../../../../components/designe/app-file/AppFile';
import { useGetMyDetails } from '../../../../services/redux/api/usersApi';
import theme from '../../../../styles/theme';
import { IBugReportMessage } from '../../../../types/interfaces/bug-report-message';
import { useStyles } from './BugReportMessage.styles';

interface IBugReportMessageProps {
  message: IBugReportMessage;
  reportUserId: string;
}

export default function BugReportMessage(props: IBugReportMessageProps) {
  const { classes } = useStyles(theme);
  const { message, reportUserId } = props;
  const isNotMyMessage = reportUserId === message.userId;
  const [selectedFile, setSelectedFile] = useState(null);

  return (
    <Box
      className={clsx(
        classes.messageWrapper,
        isNotMyMessage && classes.notMyMessage,
      )}>
      <AppEntityAvatar
        entity={message.user}
        size={AvatarSize.s}
        type={AvatarTypes.round}
      />
      <Box className={classes.messageContainer}>
        <Box className={classes.filesContainer}>
          {!!message?.files?.length &&
            message?.files.map((file) => (
              <AppFile
                key={file.id}
                file={file}
                onClick={() => {
                  setSelectedFile(file);
                }}
              />
            ))}
        </Box>
        <Typography variant="text-md"> {message.message}</Typography>
      </Box>
      {!!message?.files?.length && selectedFile && (
        <AppDocsViewer
          files={message.files}
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
        />
      )}
    </Box>
  );
}
